import { mergeStyles, mergeStyleSets } from '@fluentui/react';
import { helpbuttonStyle, convertToLocalStyle } from '@bingads-webui-campaign-react/common-styles';

const ICON_BLUE = '#0078d4';

const iconBaseClass = mergeStyles({
  height: 16,
  width: 16,
});

export const iconClassNames = mergeStyleSets({
  blue: [{ color: ICON_BLUE }, iconBaseClass],
});


export const blackColorClassName = mergeStyles({
  color: 'black',
});

export const boldClassName = mergeStyles({
  fontWeight: 'bolder',
  maxWidth: 1000,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const stackItemCenterStyle = {
  root: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
};

const reduceScopeContainer = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  '& .reduce-scope-hint': {
    padding: '15px 32px',
    borderTop: '1px solid #F3F2F1',
    '& .title': {
      fontSize: 20,
      height: 28,
      lineHeight: '28px',
      color: '#323130',
      fontWeight: 'bold',
    },
    '& .desc': {
      marginTop: 14,
      fontSize: 14,
      lineHeight: '20px',
      color: '#605E5C',
    },
  },
  '& .reduce-scope-main': {
    '& .selectors': {
      display: 'flex',
      justifyContent: 'space-between',
      marginLeft: 32,
      padding: '8px 0 47px 0',
      width: 815,
      borderTop: '1px solid #F3F2F1',
      '& .title': {
        fontSize: 14,
        lineHeight: '20px',
        color: '#323130',
        fontWeight: 'bold',
      },
      '& .date-range-select': {
        '& .ms-ChoiceField-wrapper label': {
          padding: 0,
        },
      },
    },
    '& .button-group': {
      padding: '20px 32px',
      borderTop: '1px solid #F3F2F1',
      '& button': {
        marginRight: 12,
      },
    },
  },
};

const rightPanelWidth = 560;

export const getStyles = ({ palette = {} }) => ({
  reportPreviewContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '& .user-filter-level-impl': {
      '& .body': {
        margin: '0',
        '& .help-info': {
          marginLeft: 32,
          '& .subtitle': {
            fontSize: '20px',
          },
        },
        '& .user-filter-level-input ': {
          padding: 0,
          '& .ms-TextField': {
            marginLeft: 32,
          },
          '& .ms-TextField-fieldGroup': {
            width: 300,
          },
          '& .actions': {
            marginTop: 0,
            marginLeft: 32,
            marginBottom: 10,
          },
        },
      },
    },
    '& .content-wrapper': {
      flex: 1,
      overflowY: 'auto',
      '& .main-view': {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minWidth: 900,
        '& #hotel-center-intelligence': {
          marginTop: 0,
        },
        '& .intelligence-feed-status-container': {
          marginTop: 15,
        },
      },
      '& .main-view.right-panel-expand': {
        marginRight: rightPanelWidth,
      },
      '& .right-panel-view': {
        borderLeft: 'thin solid #E1DFDD',
        backgroundColor: 'white',
        zIndex: 10,
        position: 'absolute',
        left: 'auto',
        top: '45px', // the height of sumamry bar
        bottom: 0,
        right: 0,
        width: rightPanelWidth,
      },
    },
    '& .dimension-banner': {
      '& b': {
        fontWeight: 'bold',
      },
    },
    '& .seperator-view': {
      padding: 0,
      height: 2,
    },
    '& .body': {
      flex: 1,
      overflowY: 'auto',
      display: 'flex',
      'flex-direction': 'column',
      '& .padding-container': {
        padding: '0 0 0 32px', // There should be no white space at right
        '& .disclaimer-banner': {
          paddingLeft: 0,
        },
      },
      '& .ms-DetailsHeader': {
        overflowX: 'auto',
        overflowY: 'hidden',
        '-ms-overflow-style': 'none',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },
      '& .ms-DetailsHeader .ms-DetailsHeader-cellName': {
        width: '100%',
        '& .grid-header-text': {
          wordBreak: 'break-word',
          overflow: 'hidden',
          display: 'inline-block',
          verticalAlign: 'middle',
          maxWidth: 'calc(100% - 22px)',
          textOverflow: 'ellipsis',
        },
        ...convertToLocalStyle(helpbuttonStyle({ palette })),
      },
      '& .ms-DetailsHeader-cell.freeze-column-cell.has-shadow .ms-DetailsHeader-collapseButton': {
        display: 'none',
      },
      '& .searchCategoryText': {
        fontWeight: 600,
        lineHeight: '22px',
        fontSize: '14px',
        textAlign: 'left',
      },
      '& .searchCategoryDetailButton': {
        color: '#0078D4',
        width: '100px',
        height: '16px',
        fontWeight: 400,
        lineHeight: '16px',
        border: 'none',
        background: 'transparent',
        textAlign: 'left',
      },
      '& .group-header-Chevron': {
        width: '36px',
        position: 'absolute',
        background: 'transparent',
        zIndex: 1,
        minWidth: '36px!important',
      },
      '& .ms-DetailsList-contentWrapper': {
        overflowX: 'auto',
        '-ms-overflow-style': 'none',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },
      '& .report-preview-grid .conditional-formatting-cell': {
        padding: '12px 8px 12px 12px',
        margin: '-11px -8px -11px -12px',
        height: 'calc(100% + 21px)',
        placeContent: 'center',
      },
      '& #column-chooser-wrapper': {
        marginBottom: 20,
        '& .column-chooser': {
          '& .panel': {
            marginTop: 25,
          },
        },
      },
    },
    '& .toolbar-container': {
      '& .container-fluid': {
        paddingLeft: 0,
      },
    },
    '& .reduce-scope-banner': {
      position: 'fixed',
      left: '50%',
      transform: 'translateX(-50%)',
      bottom: 70,
      background: '#EFF6FC',
      boxShadow: '0px 3px 7px rgba(0, 0, 0, 0.1)',
      height: 48,
      lineHeight: '48px',
      padding: '0 14px',
      display: 'flex',
      alignItems: 'center',
      zIndex: 9,
      '& >span': {
        margin: '0 16px 0 8px',
      },
    },
  },
  reportPreviewPoorCollapseRow: {
    '& .body .ms-List-page:last-of-type .ms-List-cell:last-of-type .ms-DetailsRow-cell': {
      borderRight: 'none',
    },
    '& .body .ms-List-page:last-of-type .ms-List-cell:last-of-type .freeze-columns-group': {
      boxShadow: 'none',
      '& .urlButton': {
        verticalAlign: 'middle',
        background: 'none',
        border: 'none',
        padding: '0',
        color: ICON_BLUE,
        cursor: 'pointer',
        '&:hover': {
          color: '#004578',
        },
      },
      ...convertToLocalStyle(helpbuttonStyle({ palette })),
    },
  },
  reportPreviewHeader: {
    marginTop: 13,
    marginBottom: 16,
    marginLeft: 32,
    marginRight: 6, // Fix bug 4037507: Column chooser icon style issue
    // minWidth: '776px',
    '& .name-container': {
      height: '44px',
    },
    '& .report-header-name-editor': {
      overflow: 'hidden',
    },
    '& .name-editor-container': {
      height: '44px',
    },
    '& .name-editor-buttons': {
      height: '44px',
      minWidth: '132px',
    },
    '& .name': {
      fontSize: '26px',
      fontWeight: 600,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    '& .report-header-timezone-selector': {
      flexShrink: 0,
    },
  },
  reportPreviewCalloutContainer: {
    '& .ms-Callout-container': {
      display: 'contents',
    },
  },
  reportPreviewCallout: {
    zIndex: '11',
    padding: '16px 16px',
    background: '#fff',
  },
  reportPreviewCalloutTitle: {
    fontWeight: 600,
  },
  reportPreviewNameInput: {
    margin: '8px 0 16px 0',
    minWidth: 258,
  },
  reportPreviewNameEditActions: {
    display: 'flex',
  },
  icons: {
    padding: 22, // Fix bug 4037507: Column chooser icon style issue
  },
  noDataplaceHolder: {
    color: '#605e5c',
    padding: '3px 0 20px 8px',
    fontSize: '26px',
    lineHeight: '36px',
  },
  reduceScopeContainer,
  insertionOrderReport: {
    '& .ms-DetailsRow-cell': {
      placeContent: 'center',
    }
  }
});
